export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/java.c1c1f53.svg";